import './App.css';
import Body from './components/Body';
import Footer from './components/Footer';

function App() {
    return (
        <div className="App">
            <header></header>
            <Body></Body>
            <Footer></Footer>
        </div>
    );
}

export default App;
